/**
 * Sidebar Redux Reducer
 * Manages the state for the DashboardSidebar component
 *
 * Adds:
 * - ability to set sx.rootSx / sx.headerSx / sx.bodySx individually
 * - ability to set all sx keys at once
 * - reset to initialState whenever sidebar closes
 */

// Action Types
export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SIDEBAR_CLOSE = "SIDEBAR_CLOSE";
export const SIDEBAR_UPDATE_DATA = "SIDEBAR_UPDATE_DATA";

// NEW: sx action types
export const SIDEBAR_SET_SX = "SIDEBAR_SET_SX";
export const SIDEBAR_SET_ROOT_SX = "SIDEBAR_SET_ROOT_SX";
export const SIDEBAR_SET_HEADER_SX = "SIDEBAR_SET_HEADER_SX";
export const SIDEBAR_SET_BODY_SX = "SIDEBAR_SET_BODY_SX";

// Action Creators
export const sidebarOpen = (type, data = null, metadata = null) => ({
  type: SIDEBAR_OPEN,
  payload: { type, data, metadata },
});

export const sidebarClose = () => ({
  type: SIDEBAR_CLOSE,
});

export const sidebarUpdateData = (data) => ({
  type: SIDEBAR_UPDATE_DATA,
  payload: data,
});

// NEW: sx action creators

// Set 1+ sx buckets at once: { rootSx, headerSx, bodySx }
export const sidebarSetSx = (sx = {}) => ({
  type: SIDEBAR_SET_SX,
  payload: sx,
});

// Set individual buckets
export const sidebarSetRootSx = (rootSx = {}) => ({
  type: SIDEBAR_SET_ROOT_SX,
  payload: rootSx,
});

export const sidebarSetHeaderSx = (headerSx = {}) => ({
  type: SIDEBAR_SET_HEADER_SX,
  payload: headerSx,
});

export const sidebarSetBodySx = (bodySx = {}) => ({
  type: SIDEBAR_SET_BODY_SX,
  payload: bodySx,
});

// Initial State
const initialState = {
  isOpen: false,
  type: null,
  data: null,
  metadata: null,
  sx: {
    rootSx: {},
    headerSx: {},
    bodySx: {},
  },
};

// Reducer
const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIDEBAR_OPEN:
      // keep any existing sx unless you want open to reset sx too
      return {
        ...state,
        isOpen: true,
        type: action.payload.type,
        data: action.payload.data,
        metadata: action.payload.metadata,
      };

    case SIDEBAR_CLOSE:
      // resets everything every close (as requested)
      return initialState;

    case SIDEBAR_UPDATE_DATA:
      return {
        ...state,
        data: action.payload,
      };

    // sx handlers

    case SIDEBAR_SET_SX: {
      const next = action.payload || {};
      return {
        ...state,
        sx: {
          ...state.sx,
          ...(next.rootSx ? { rootSx: next.rootSx } : null),
          ...(next.headerSx ? { headerSx: next.headerSx } : null),
          ...(next.bodySx ? { bodySx: next.bodySx } : null),
        },
      };
    }

    case SIDEBAR_SET_ROOT_SX:
      return {
        ...state,
        sx: {
          ...state.sx,
          rootSx: action.payload || {},
        },
      };

    case SIDEBAR_SET_HEADER_SX:
      return {
        ...state,
        sx: {
          ...state.sx,
          headerSx: action.payload || {},
        },
      };

    case SIDEBAR_SET_BODY_SX:
      return {
        ...state,
        sx: {
          ...state.sx,
          bodySx: action.payload || {},
        },
      };

    default:
      return state;
  }
};

export default sidebarReducer;
